import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { RestService } from 'src/app/services/rest.service';
import { GlobalvarsService } from 'src/app/services/globalvars.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  username: string = "";
  password: string = "";
  errorMessage: string = "";
  errorStyles = { 'display': 'none' };

  public loginPage: boolean = false
  public version:any = "1.0"

  constructor(
    private renderer: Renderer2,
    private rest: RestService,
    private globalvar: GlobalvarsService,
    private router: Router
  ) {
    // Set page background
    this.renderer.addClass(document.body, 'pageBodyLogin');
    
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'pageBodyLogin');
  }

  login() {
    if (!this.username || !this.password) {
      this.errorMessage = "Wrong username or password";
      this.errorStyles = { 'display': 'block' };
    } else {
      // Check against rest api
      this.rest.login(this.username, this.password)
        .then(value => {
          const retValue: any = value;
          this.globalvar.storeToken(retValue);
          this.router.navigateByUrl('/');
        })
        .catch(err => {
          this.errorMessage = "Wrong username or password (" + err.status + ")";
          this.errorStyles = { 'display': 'block' };
          console.log(err)
        })
    }
  }
}
